import { render, staticRenderFns } from "./PwdReset.vue?vue&type=template&id=349d814e&scoped=true&"
import script from "./PwdReset.vue?vue&type=script&lang=js&"
export * from "./PwdReset.vue?vue&type=script&lang=js&"
import style0 from "./PwdReset.vue?vue&type=style&index=0&id=349d814e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d814e",
  null
  
)

export default component.exports